import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NeoLoaderModule } from '@neogov/pattern-library/neo-loader';

export type SpinnerSize = 'small' | 'medium' | 'large';
export type SpinnerMode = 'inline' | 'overlay';

@Component({
  selector: 'cm-spinner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NeoLoaderModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.less',
})
export class SpinnerComponent {
  public readonly loading = input<boolean>(false);
  public readonly size = input<SpinnerSize>('medium');
  /** Message announced to assistive tech while loading (WCAG 4.1.3). */
  public readonly loadingText = input<string>('Loading');
}
